<template>
    <div id="stations">
        <!-- Messages -->
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <Filters></Filters>

        <div class="ui segment">
            <div v-if="style.width < 767" style="margin-bottom: 1em;">
                <div v-if="is_loading">
                    <div class="ui active centered inline loader"></div>
                </div>
                <DataCard
                    v-else
                    v-for="station in stations"
                    :key="station.identity"
                    :object="station"
                    :title="station.name"
                    :title_link="{name: 'edit_station', params: {station_identity: station.identity}}"
                    :sub_title="station.code"
                    :is_show_column="true"
                    :keys="['phone','note']"
                    :i_18n_key="'stations'"
                >
                    <div slot="buttons">
                        <a @click.prevent="delete_station(station)" class="ui basic red button">
                            {{ $t('ui.general.delete') }}
                        </a>
                    </div>
                </DataCard>

                <div v-if="!is_loading && stations.length <= 0"
                    class="ui center aligned red segment">
                    <h3>
                        {{ $t('ui.general.no_data') }}
                    </h3>
                </div>
            </div>
            <table v-else class="ui celled table">
                <thead class="center aligned">
                    <tr>
                        <th>{{ $t('models.attributes.stations.name') }}</th>
                        <th>{{ $t('models.attributes.stations.code') }}</th>
                        <th>{{ $t('models.attributes.stations.phone') }}</th>
                        <th>{{ $t('models.attributes.stations.note') }}</th>
                        <th>{{ $t('ui.general.operate') }}</th>
                    </tr>
                </thead>
                <!-- Data loader -->
                <tbody v-if="is_loading" class="center aligned">
                    <tr class="loading">
                        <td colspan="5">
                            <div class="ui active centered inline loader"></div>
                        </td>
                    </tr>
                </tbody>
                <!-- Data contents -->
                <tbody v-else class="center aligned">
                    <Row v-for="station in stations" :key="station.identity" :station="station">
                    </Row>
                    <tr v-if="stations.length <= 0" class="center aligned">
                        <td colspan="5">
                            <h5>{{ $t('ui.general.no_data') }}</h5>
                        </td>
                    </tr>
                </tbody>
            </table>

            <Paginator
                :total_pages="Number(pagination.total_pages)"
                :current_page="Number(pagination.current_page)">
            </Paginator>
        </div>
    </div>
</template>

<script>
import Row from "./row.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
import ErrorMessages from '@toolbox/error_box/main.vue'
import DataCard from '@toolbox/data_card/main.vue'
import Filters from "./filter/main.vue"

export default {
    name: "StationsIndex",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            is_search_params_changed: false,
            errors: [],
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        current_store() {
            return this.$store.state.provider.stations_module
        },
        stations() {
            return this.current_store.stations
        },
        pagination() {
            return this.current_store.pagination
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$off('init')
        this.$bus.$on('init', (value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
        this.pagination.current_page = 1
    },
    watch: {
        '$route'(to, from) {
            this.init(false)
        },
    },
    methods: {
        async init(is_first = true) {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    this.is_loading = true
                    resolve()
                })
                await this.$store.dispatch('provider/stations_module/handle_query_to_filter',{
                    query: this.$route.query
                })
                if (is_first) {
                    await this.$store.dispatch('provider/stations_module/handle_quick_filter_key')
                }
                await this.$store.dispatch('provider/stations_module/fetch_stations')
            } catch (e) {
                switch (e) {
                    default:
                    console.log("init error: ")
                    console.log(e)
                }
            } finally {
                this.is_initialized = true
                this.is_loading = false
                this.$noty.information(
                    this.$t("ui.page_titles.stations") + ' ' +
                    this.$t('ui.general.initialize_complete')
                , 300)
            }
        },
        stations_filter() {
            console.log('stations_filter')
            try {
                this.$router.push({
                    name: this.$router.name,
                    query: this.$store.getters['provider/stations_module/filter_to_query'],
                })
            } catch (e) {
                console.log(e)
            }
        },
        delete_station(station) {
            if (confirm(this.$t('ui.notifications.warning.are_you_sure_to_delete_it'))) {
                this.is_loading = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_station_delete).parse(
                    {
                        "station_identity": station.identity,
                    },
                )

                axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        // this.$noty.success("站點刪除成功")
                        this.$noty.success(
                            this.$t('ui.notifications.success.delete__name', {
                                name: this.$t('models.stations')
                            })
                        )
                        this.init(false)
                    } else {
                        // this.$noty.error("站點刪除失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.delete__name', {
                                name: this.$t('models.stations')
                            })
                        )
                    }
                })
                .catch(error => {
                    console.log(error)
                    if (!error.response) {
                        // Network Error
                        this.$noty.error(
                            this.$t('ui.general.network_abnormality')+": "+
                            this.$t('ui.general.server_offline')
                        )
                    } else {
                        this.$noty.error(this.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data)
                    }
                })
                .finally(() => {
                    this.is_loading = false
                })
            }
        },
    },
    components: {
        Row,
        Paginator,
        ErrorMessages,
        DataCard,
        Filters
    }
}
</script>
